import { render } from "./WrapWithOnlyButton.vue?vue&type=template&id=7b71fc80"
import script from "./WrapWithOnlyButton.vue?vue&type=script&lang=js"
export * from "./WrapWithOnlyButton.vue?vue&type=script&lang=js"

import "./WrapWithOnlyButton.vue?vue&type=style&index=0&id=7b71fc80&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__